import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PusherAuthModel } from '../../models';
import { AbstractPusherConfigService } from '../abstract-pusher-config/abstract-pusher-config.service';

@Injectable()
export class PusherApiService {
  constructor(
    private httpClient: HttpClient,
    private config: AbstractPusherConfigService,
  ) { }

  authenticate(channel_name: string, socket_id: string): Observable<PusherAuthModel> {
    const formData = new FormData();
    formData.append('channel_name', channel_name);
    formData.append('socket_id', socket_id);
    return this.httpClient.post<PusherAuthModel>(
      `${this.config.getConfig().authApiUrl}/${this.config.getConfig().authEndpoint}`,
      formData
    );
  }
}
